import React from 'react';

import BottomSheet from 'components/BottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Title,  AddButton } from './styles';

interface Props {
  show: boolean;
  onAdd: () => void;
  onImport: () => void;
  onClose: () => void;
}

const ImportOrAdd = ({ show, onAdd, onImport, onClose }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <>
      <BottomSheet noHeader noPadding show={show} onClose={onClose} modal>
        <Container>
          <Title>{t('expensesList.importOrAdd.title')}</Title>
          <AddButton invertedColor value={t('expensesList.importOrAdd.add')} onClick={onAdd} />
        </Container>
      </BottomSheet>
    </>
  );
};

export default ImportOrAdd;
